import { useRef, useState } from "react";
import { toast } from "sonner";
import { ScanLine, Loader2, Camera, FileText, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const OcrFill = ({ onFilled }) => {
  const imgRef = useRef();
  const docRef = useRef();
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const add = (list) => { const arr = Array.from(list || []); if (!arr.length) return; setFiles((f) => [...f, ...arr].slice(0, 8)); setResult(null); };
  const run = async () => {
    if (!files.length) return;
    setBusy(true); setResult(null);
    try {
      const fd = new FormData(); files.forEach((f) => fd.append("files", f));
      const r = await api.post("/ai/ocr", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const filled = onFilled(r.data.fields);
      setResult({ ...r.data, filled });
      toast.success(`${filled} field terisi dari ${r.data.docs.length} dokumen — periksa kembali sebelum simpan`);
      setFiles([]);
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); if (imgRef.current) imgRef.current.value = ""; if (docRef.current) docRef.current.value = ""; }
  };
  return (
    <div className="sm:col-span-2 rounded-lg border border-dashed border-primary/40 bg-primary/5 p-3 space-y-2" data-testid="ocr-fill">
      <div className="flex flex-wrap items-center gap-2">
        <ScanLine className="h-4 w-4 text-primary" />
        <span className="text-xs font-medium flex-1">Isi otomatis dari dokumen (AI) — unggah KTP, KK, Ijazah, Paspor, CV sekaligus; jenis dokumen dikenali otomatis</span>
        <input ref={imgRef} type="file" accept="image/*" capture="environment" multiple className="hidden" onChange={(e) => add(e.target.files)} data-testid="ocr-image-input" />
        <input ref={docRef} type="file" accept=".pdf,.docx,.txt,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple className="hidden" onChange={(e) => add(e.target.files)} data-testid="ocr-doc-input" />
        <Button type="button" size="sm" variant="outline" disabled={busy} onClick={() => imgRef.current?.click()} data-testid="ocr-image-button"><Camera className="h-3.5 w-3.5 mr-1" />Gambar / Foto</Button>
        <Button type="button" size="sm" variant="outline" disabled={busy} onClick={() => docRef.current?.click()} data-testid="ocr-doc-button"><FileText className="h-3.5 w-3.5 mr-1" />PDF / Word</Button>
      </div>
      {files.length > 0 && <div className="flex flex-wrap items-center gap-1.5" data-testid="ocr-file-list">
        {files.map((f, i) => <span key={i} className="inline-flex items-center gap-1 rounded-full bg-background border border-border px-2 py-0.5 text-[11px]" data-testid={`ocr-file-${i}`}>{f.name}<button type="button" onClick={() => setFiles((x) => x.filter((_, j) => j !== i))} className="text-muted-foreground hover:text-destructive"><X className="h-3 w-3" /></button></span>)}
        <Button type="button" size="sm" disabled={busy} onClick={run} data-testid="ocr-run-button" className="ml-auto">{busy ? <><Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />Membaca {files.length} dokumen…</> : `Baca ${files.length} dokumen`}</Button>
      </div>}
      {result && <div className="text-[11px] text-muted-foreground space-y-0.5" data-testid="ocr-result">
        <p>Terdeteksi: {result.docs.map((d) => d.label).join(", ")} · Keyakinan {Math.round((result.confidence || 0) * 100)}%</p>
        {result.warnings?.length > 0 && <p>{result.warnings.join("; ")}</p>}
        {result.duplicate && <p className="text-destructive font-medium" data-testid="ocr-duplicate">NIK ini sudah terdaftar atas nama {result.duplicate.name} ({result.duplicate.yutaka_id})</p>}
      </div>}
    </div>
  );
};
